<ui-expander-header-base [expanded]="expanded()" (expandedChange)="expanded.set($event)">
  @if (headerTemplate()) {
    <ng-container *ngTemplateOutlet="headerTemplate(); context:{expanded: expanded()}"></ng-container>
  } @else {
    <div class="wrapper-header">
      <div class="wrapper-title">
        <span>{{ title() }}</span>
        @if (badge(); as badge) {
          <span class="expander-badge">{{ badge }}</span>
        }
      </div>

      <ui-icon [faName]="expanded() ? 'chevron-up' : 'chevron-down'" faStyle="solid"></ui-icon>
    </div>
  }
</ui-expander-header-base>

<ui-expander-content [expanded]="expanded()">
  <ng-content></ng-content>
</ui-expander-content>
